import React, { useState } from 'react';
import './ContactUsPage.css';
import Products2Hero from '../components/Products2Hero';

/* ─── Icons ─────────────────────────────────── */
const MailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ChatIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const ArrowUpRight = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="7" y1="17" x2="17" y2="7" />
    <polyline points="7 7 17 7 17 17" />
  </svg>
);

const CopyIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ClockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

/* ─── Channel Card ──────────────────────────── */
const ChannelCard = ({ icon, label, title, value, href, copyable, meta }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const Wrapper = href ? 'a' : 'div';
  const wrapperProps = href ? { href } : {};

  return (
    <Wrapper className="cu-channel" {...wrapperProps}>
      <div className="cu-channel-icon">{icon}</div>
      <div className="cu-channel-body">
        <span className="cu-channel-label">{label}</span>
        <h3 className="cu-channel-title">{title}</h3>
        <p className="cu-channel-value">{value}</p>
        {meta && <span className="cu-channel-meta">{meta}</span>}
      </div>
      {copyable && (
        <button
          className="cu-channel-copy"
          onClick={handleCopy}
          aria-label={`Copy ${label}`}
        >
          {copied ? <CheckIcon /> : <CopyIcon />}
        </button>
      )}
      {href && !copyable && (
        <span className="cu-channel-arrow"><ArrowUpRight /></span>
      )}
    </Wrapper>
  );
};

/* ─── Page ──────────────────────────────────── */
const ContactUsPage = () => {
  const contactMarquee = [
    '24/7 Support Available',
    'Certified Tech Assistance',
    'Operational Hub Hyderabad',
    'Rapid Response Team',
    'Customer Care First',
    'Direct Tech Consultations'
  ];

  return (
    <div className="cu-page">
      <Products2Hero
        className="hero-tight"
        tagline="NEXAWAVE SUPPORT · 24/7 ASSISTANCE · HYDERABAD OPERATIONAL HUB"
        title1="Contact Us"
        title2=""
        title3=""
        description=""
        marqueeItems={contactMarquee}
      />

      <section className="cu-section">
        <div className="cu-container">

          {/* Section header */}
          <header className="cu-intro">
            <p className="cu-kicker">Contact</p>
            <h2 className="cu-title">
              We're here to help.<br />
              <span>Pick the channel that suits you.</span>
            </h2>
            <p className="cu-lede">
              Whether you have a question about a product, need technical assistance,
              or just want to share feedback — our team responds within one business day.
            </p>
          </header>

          {/* Primary channels grid */}
          <div className="cu-channels">
            <ChannelCard
              icon={<MailIcon />}
              label="Email"
              title="General enquiries"
              value="support@nexawavetechnology.com"
              href="mailto:support@nexawavetechnology.com"
              copyable
              meta="Replies within 24 hours"
            />
            <ChannelCard
              icon={<PhoneIcon />}
              label="Phone"
              title="Talk to a specialist"
              value="+91 63035 61201"
              href="tel:+916303561201"
              copyable
              meta="Mon–Sat, 10:00 – 19:00 IST"
            />
            <ChannelCard
              icon={<ChatIcon />}
              label="Help Center"
              title="Browse articles"
              value="Common questions and how-to guides"
              href="/help-center"
            />
            <ChannelCard
              icon={<MapPinIcon />}
              label="Visit"
              title="Hyderabad office"
              value="Farhat Nagar, Telangana 500023"
              href="https://maps.google.com/?q=Farhat+Nagar+Hyderabad+500023"
              meta="By appointment only"
            />
          </div>

          {/* Two-column: Office + Legal */}
          <div className="cu-grid">

            {/* Office card */}
            <article className="cu-card cu-office">
              <div className="cu-card-head">
                <span className="cu-tag">
                  <span className="cu-tag-dot" />
                  Open today
                </span>
                <h3 className="cu-card-title">Operational headquarters</h3>
              </div>

              <address className="cu-address">
                H.No. 16-5-1/4, Farhat Nagar<br />
                Hyderabad, Telangana 500023<br />
                India
              </address>

              <dl className="cu-hours">
                <div className="cu-hours-row">
                  <dt><ClockIcon /> Monday – Friday</dt>
                  <dd>10:00 – 19:00</dd>
                </div>
                <div className="cu-hours-row">
                  <dt><ClockIcon /> Saturday</dt>
                  <dd>10:00 – 16:00</dd>
                </div>
                <div className="cu-hours-row cu-hours-row--muted">
                  <dt><ClockIcon /> Sunday</dt>
                  <dd>Closed</dd>
                </div>
              </dl>

              <a
                className="cu-card-link"
                href="https://maps.google.com/?q=Farhat+Nagar+Hyderabad+500023"
                target="_blank"
                rel="noreferrer"
              >
                Open in Maps <ArrowUpRight />
              </a>
            </article>

            {/* Legal card */}
            <article className="cu-card cu-legal">
              <div className="cu-card-head">
                <span className="cu-tag cu-tag--neutral">Legal</span>
                <h3 className="cu-card-title">Registered entity</h3>
              </div>

              <dl className="cu-legal-list">
                <div className="cu-legal-row">
                  <dt>Legal name</dt>
                  <dd>Nexawave Software Solutions Private Limited</dd>
                </div>
                <div className="cu-legal-row">
                  <dt>Registered office</dt>
                  <dd>H.No. 16-5-1/4, Farhat Nagar, Hyderabad, Telangana 500023</dd>
                </div>
                <div className="cu-legal-row">
                  <dt>Operational office</dt>
                  <dd>Same as registered address</dd>
                </div>
                <div className="cu-legal-row">
                  <dt>Email</dt>
                  <dd>
                    <a href="mailto:support@nexawavetechnology.com">
                      support@nexawavetechnology.com
                    </a>
                  </dd>
                </div>
                <div className="cu-legal-row">
                  <dt>Telephone</dt>
                  <dd><a href="tel:+916303561201">+91 63035 61201</a></dd>
                </div>
              </dl>
            </article>
          </div>

          {/* Disclaimer */}
          <footer className="cu-disclaimer">
            <p>
              The information above is provided by Nexawave Software Solutions
              Private Limited at its sole discretion. Razorpay is not liable for
              any content shown here and bears no responsibility for claims arising
              from merchant non-adherence.
            </p>
          </footer>
        </div>
      </section>
    </div>
  );
};

export default ContactUsPage;